'use strict';

DoohApps
.filter('timezone', function () {
    return function (time, format) {                
        return moment.utc(time).tz(localStorage['TimeZoneIANA'])
            .format(
            format.replace('yyyy', 'YYYY')
                  .replace('dd', 'DD')
                  );
  };
})